module.exports = __webpack_public_path__ + "img/img42.44c2bdfa.png";